import cx from 'classnames';
import Typography from 'components/typography/Typography';
import { TYPOGRAPHY_VARIANTS } from 'components/typography/typography-utils';
import { I18nNamespace } from 'constants/i18n.const';
import { useTranslation } from 'hooks/useTranslation';
import React, { HtmlHTMLAttributes } from 'react';

export type PageTitleProps = HtmlHTMLAttributes<HTMLDivElement> & {
  i18nCode: any | string | null | undefined;
};

const PageTitle: React.FC<PageTitleProps> = ({ i18nCode, ...rest }) => {
  const { T } = useTranslation(I18nNamespace.COMMON);

  return i18nCode ? (
    <>
      <div {...rest} className={cx('page-title-wrapper', rest?.className)}>
        <Typography
          variant={TYPOGRAPHY_VARIANTS.H1}
          data-text={T(i18nCode)}
          className="page-title"
        >
          {T(i18nCode)}
        </Typography>
      </div>
    </>
  ) : null;
};

export default PageTitle;
